import { render } from "./C_Puppies.vue?vue&type=template&id=8a8168aa&scoped=true"
import script from "./C_Puppies.vue?vue&type=script&lang=js"
export * from "./C_Puppies.vue?vue&type=script&lang=js"

import "./C_Puppies.vue?vue&type=style&index=0&id=8a8168aa&scoped=true&lang=css"

import exportComponent from "/Users/jessicabohland/Documents/Code/Website/gonsbachtal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a8168aa"]])

export default __exports__